import styled from "styled-components";

export const StyledContainerCompany = styled.div`
    display: flex;
    flex-direction: column;
`;